$(document).ready(function() {
  var timeout = null;

  reloadCheckoutPage(timeout);
  const callreloadCheckoutPage = () => reloadCheckoutPage(timeout);
  window.callreloadCheckoutPage = callreloadCheckoutPage;

  // Initialize shipping fee calculation if shipping is allowed
  initShippingFeeCalculation();
});

function reloadCheckoutPage(timeout){
  window.addEventListener( "pageshow", function ( event ) {
    var historyTraversal = event.persisted || 
                          ( typeof window.performance != "undefined" && 
                                window.performance.navigation.type === 2 );

    const d = new Date();
    let time = d.getTime();

    var startDate = new Date(time * 1000);
    var endDate   = new Date();
    var seconds = (endDate.getTime() - startDate.getTime());
    var expired = seconds > 1000 * 60 * 3; // 3 minutes

    if ( historyTraversal && expired ) {
      // Handle page reload.
      window.location.reload();
    }
  });
}

function initShippingFeeCalculation() {
  var $checkoutContainer = $('.row.checkout');
  var allowShipping = $checkoutContainer.data('allow-shipping') === true || $checkoutContainer.data('allow-shipping') === 'true';

  if (!allowShipping) {
    return;
  }

  var shipFeeUrl = $checkoutContainer.data('ship-fee-url');
  var shippingFeeLabel = $checkoutContainer.data('shipping-fee-label');
  var taxAmountLabel = $checkoutContainer.data('tax-amount-label');

  // Calculate shipping fee for initially selected address (silently, no alerts)
  var initialAddress = $(".order-address-list input[type=radio]:checked");
  if (initialAddress.length > 0 && !$("input[name='self_collection']").is(":checked")) {
    var addressId = initialAddress.val();
    updateShippingFee(addressId, shipFeeUrl, false); // false = don't show alerts on page load
  }

  // Function to enable/disable place order button based on shipping validation
  function updatePlaceOrderButtonState() {
    var $placeOrderBtn = $('#btn-place-order');
    if (!allowShipping) {
      $placeOrderBtn.prop('disabled', false);
      return;
    }

    var selfCollection = $("input[name='self_collection']").is(":checked");
    var addressSelected = $(".order-address-list input[type=radio]:checked").length > 0;

    if (selfCollection || addressSelected) {
      $placeOrderBtn.prop('disabled', false);
    } else {
      $placeOrderBtn.prop('disabled', true);
    }
  }

  // Initialize button state on page load
  updatePlaceOrderButtonState();

  // Handle self collection checkbox change
  $("input[name='self_collection']").change(function() {
    if ($(this).is(":checked")) {
      $(".order-address-list input[type=radio]:checked").prop('checked', false);
      updateShippingFee(null, shipFeeUrl, true); // Show alerts when user checks self collection
    }
    updatePlaceOrderButtonState();
  });

  // Handle address radio button change
  $(".order-address-list input[type=radio]").change(function() {
    if ($(this).is(":checked")) {
      $("input[name='self_collection']").prop('checked', false);
      var addressId = $(this).val();
      updateShippingFee(addressId, shipFeeUrl, true); // true = show alerts when user selects address
    }
    updatePlaceOrderButtonState();
  });

  // Handle clicks on the address card itself
  $(".mailing__card").click(function(e) {
    // Don't trigger if clicking directly on the radio button (it will trigger its own change event)
    if ($(e.target).is('input[type=radio]')) {
      return;
    }

    var radioButton = $(this).find('input[type=radio]');
    if (radioButton.length > 0) {
      radioButton.prop('checked', true);
      $("input[name='self_collection']").prop('checked', false);
      var addressId = radioButton.val();
      updateShippingFee(addressId, shipFeeUrl, true); // true = show alerts when user clicks address card
      updatePlaceOrderButtonState();
    }
  });

  $(".order-address-list").click(function(){
    $("input[name='self_collection']").prop('checked', false);
    updatePlaceOrderButtonState();
  });

  function updateShippingFee(addressId, url, showAlerts) {
    // showAlerts defaults to true if not specified (for backward compatibility)
    showAlerts = showAlerts !== false;

    var allowShipping = true; // Already checked in initShippingFeeCalculation
    var selfCollection = $("input[name='self_collection']").is(":checked");
    var cartItemIds = [];
    $("input[name='checkout[cart_item_ids][]']").each(function() {
      cartItemIds.push($(this).val());
    });

    if (!allowShipping || selfCollection || !addressId) {
      // Reset shipping fee to 0
      updateShippingFeeDisplay(0, shippingFeeLabel, taxAmountLabel);
      updateTotalAmount();
      return;
    }

    $.ajax({
      url: url,
      method: 'POST',
      data: {
        address_id: addressId,
        cart_item_ids: cartItemIds,
        authenticity_token: $('meta[name="csrf-token"]').attr('content')
      },
      success: function(response) {
        if (response.error) {
          if (showAlerts) {
            alert(response.error);
          }
          updateShippingFeeDisplay(0, shippingFeeLabel, taxAmountLabel);
        } else {
          updateShippingFeeDisplay(response.ship_fee, shippingFeeLabel, taxAmountLabel);
        }
        updateTotalAmount();
      },
      error: function(xhr) {
        var errorMsg = 'Failed to calculate shipping fee';
        if (xhr.responseJSON && xhr.responseJSON.error) {
          errorMsg = xhr.responseJSON.error;
        }
        if (showAlerts) {
          alert(errorMsg);
        }
        updateShippingFeeDisplay(0, shippingFeeLabel, taxAmountLabel);
        updateTotalAmount();
      }
    });
  }

  function updateShippingFeeDisplay(shipFee, shippingFeeLabel, taxAmountLabel) {
    var shipFeeRow = $('#shipping_fee_row');

    if (shipFee > 0) {
      if (shipFeeRow.length === 0) {
        // Insert shipping fee row after tax amount row if it doesn't exist
        var taxRow = $('tr:has(td:contains("' + taxAmountLabel + '"))');
        var newRow = '<tr id="shipping_fee_row"><td class="payment-title pl-0">' + shippingFeeLabel + '</td><td class="text-right text-dark"><strong id="ship_fee_amount">' + formatMoney(shipFee) + '</strong></td></tr>';
        taxRow.after(newRow);
      } else {
        $('#ship_fee_amount').text(formatMoney(shipFee));
        shipFeeRow.show();
      }
    } else {
      if (shipFeeRow.length > 0) {
        shipFeeRow.hide();
      }
    }
  }

  function formatMoney(amount) {
    return 'RM ' + parseFloat(amount).toFixed(2);
  }

  function updateTotalAmount() {
    // The total will be recalculated server-side when the form is submitted
    // For now, we just show the updated shipping fee
    // Full recalculation would require a page refresh or additional AJAX call
  }

  // Validate shipping address selection before form submission
  $('#form-place-order').submit(function(e) {
    if (!allowShipping) {
      return true; // No validation needed if shipping is not allowed
    }

    var selfCollection = $("input[name='self_collection']").is(":checked");
    var addressSelected = $(".order-address-list input[type=radio]:checked").length > 0;

    if (!selfCollection && !addressSelected) {
      e.preventDefault();
      alert('Please select a delivery address or choose self collection');
      return false;
    }

    // Validate address completeness and shipping availability if address is selected
    if (!selfCollection && addressSelected) {
      var selectedAddressId = $(".order-address-list input[type=radio]:checked").val();
      var addressCard = $(".order-address-list input[type=radio][value='" + selectedAddressId + "']").closest('.mailing__card');
      var validationFailed = false;
      var errorMessage = '';

      // Check address completeness and shipping availability via AJAX
      $.ajax({
        url: shipFeeUrl,
        method: 'POST',
        async: false,
        data: {
          address_id: selectedAddressId,
          cart_item_ids: $("input[name='checkout[cart_item_ids][]']").map(function() { return $(this).val(); }).get(),
          authenticity_token: $('meta[name="csrf-token"]').attr('content'),
          validate_only: true
        },
        success: function(response) {
          // Check if response contains an error (even in success response)
          if (response.error) {
            validationFailed = true;
            errorMessage = response.error;
          }
        },
        error: function(xhr) {
          if (xhr.status === 400 && xhr.responseJSON && xhr.responseJSON.error) {
            validationFailed = true;
            errorMessage = xhr.responseJSON.error;
          }
        }
      });

      // Block order placement if validation failed
      if (validationFailed && errorMessage) {
        e.preventDefault();
        alert(errorMessage);
        return false;
      }
    }

    return true;
  });

  // Make updateShippingFee available globally if needed
  window.updateShippingFee = function(addressId) {
    updateShippingFee(addressId, shipFeeUrl, true); // Show alerts when called globally
  };
}
